<template>
    <div class="container">
        <breadcrumb-top :breadcrumbConfig="dataList" isBack="1"></breadcrumb-top>
        <div class="content c-top">
            <div style="display: flex">
                <div class="info1">礼道设置</div>
                <div class="info1" style="margin-left: 7px">/</div>
                <div>
                    <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
                        <el-menu-item v-for="(item, index) in btns" :index="index.toString()" :key="index">{{ item.name
                        }}</el-menu-item>
                    </el-menu>
                </div>
            </div>
            <div>
                <el-form :inline="true" :model="searchForm" ref="searchForm" size="small">
                    <el-form-item label="标题" prop="title">
                        <el-input style="width: 232px" v-model="searchForm.title" placeholder="请输入标题" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="创建时间" prop="createdTimeStart">
                        <el-date-picker v-model="value1" style="width: 232px" type="daterange" range-separator="至"
                            start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="最近编辑时间" prop="updatedTimeStart">
                        <el-date-picker v-model="value2" style="width: 232px" type="daterange" range-separator="至"
                            start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="状态" prop="status">
                        <el-select style="width: 232px" v-model="searchForm.status" placeholder="请选择状态" filterable
                            clearable>
                            <el-option label="启用" value="1"></el-option>
                            <el-option label="禁用" value="0"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item class="form-btn">
                        <el-button type="primary" @click="fetchData('search')">查询</el-button>
                        <el-button type="primary" plain @click="fetchData('reset')">重置</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="content">
            <div class="title">
                <h3>列表数据</h3>
                <div>
                    <el-button type="primary" @click="uploadBanner" size="small">轮播图设置</el-button>
                    <el-button type="primary" @click="toArticleComment" size="small">文章评论</el-button>
                    <el-button type="primary" @click="options('add')" size="small" icon="el-icon-plus">新增内容</el-button>
                    <el-button @click="deleteAll()" size="small" icon="el-icon-delete">批量删除</el-button>
                </div>
            </div>
            <div id="base-list" style="margin-top: 20px;">
                <lb-table v-horizontal-scroll="'always'" :column="columns" :data="list" pagination :total="page.totalNum"
                    layout="total, sizes, prev, pager, next, jumper" :page-sizes="[5, 10, 20, 30, 50]"
                    :current-page.sync="page.pageNo" :page-size="page.pageSize" @selection-change="onMultipleSelection"
                    @size-change="handleSizeChange" @p-current-change="handleCurrentChange">
                </lb-table>
            </div>
        </div>
        <el-dialog title="温馨提示" :visible.sync="isD" width="518px" :append-to-body="true" top="calc(50vh - 100px)">
            <template>
                <div class="info" style="text-align: left">
                    <i class="el-icon-warning" style="color: orange; font-size: 20px"></i>
                    是否确认删除，删除后数据不可恢复！
                </div>
                <div style="display: flex; justify-content: end; margin-top: 24px">
                    <div class="info-q" @click="isD = false">取消</div>
                    <div class="info-s" @click="submitD">确定</div>
                </div>
            </template>
        </el-dialog>
        <el-dialog title="提示信息" :visible.sync="isS" width="518px" :append-to-body="true" top="calc(50vh - 100px)">
            <template>
                <div class="info" style="text-align: left" v-if="statusS == '0'">
                    <i class="el-icon-warning" style="color: orange; font-size: 20px"></i>
                    是否操作为【启用】状态？
                </div>
                <div class="info" style="text-align: left" v-else>
                    <i class="el-icon-warning" style="color: orange; font-size: 20px"></i>
                    是否操作为【禁用】状态？
                </div>
                <div style="display: flex; justify-content: end; margin-top: 24px">
                    <div class="info-q" @click="isS = false">取消</div>
                    <div class="info-s" @click="submitA">确定</div>
                </div>
            </template>
        </el-dialog>
        <el-dialog title="轮播图上传" :visible.sync="isL" width="800px" :append-to-body="true">
            <el-form ref="form" label-width="100px" class="info-form" style="margin-top: 22px" :model="form">
                <el-form-item label="轮播图" prop="banner">
                    <label slot="label">轮播图({{
                        fileList.length
                    }}/5)</label>
                    <upload-picture :limit="5" :list="fileList" @changeImage="changeImage" />

                </el-form-item>
                <el-form-item>
                    <div class="p-info">图片尺寸：建议上传750px*400px，每张上传大小不得超过2M,支持jpg、jpeg、png格式</div>
                </el-form-item>
            </el-form>
            <div style="display: flex; justify-content: end; margin-top: 24px">
                <div class="info-q" @click="isL = false">取消</div>
                <div class="info-s" @click="submitL">确定</div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import breadcrumbTop from '../../../components/breadcrumb.vue'
import LbTable from '../../../components/lb-table/lb-table'
import uploadPicture from '@/components/upload/dragpicture1.vue'
export default {
    components: {
        breadcrumbTop,
        LbTable,
        uploadPicture
    },
    data() {
        return {
            selectD: [],
            fileList: [],
            dataList: {
                list: [
                    { title: 'APP设置', path: '', type: '0' },
                    { title: '礼道设置', path: '', type: '1' }
                ]
            },
            activeIndex: '0',
            btns: ['礼文化', '礼分享', '礼精选'],
            searchForm: {
                title: '',
                goodsArticleCategoryId: '',
                pageNo: 1,
                pageSize: 10,
                createdTimeStart: '',
                createdTimeEnd: '',
                updatedTimeStart: '',
                updatedTimeEnd: '',
                status: ''
            },
            value1: [],
            value2: [],
            columns: [
                { type: 'selection', minWidth: '80', fixed: 'left' },
                {
                    label: '主图', prop: 'image', minWidth: '100',
                    render: (h, scope) => {
                        let img = scope.row.mainImageArr ? scope.row.mainImageArr : []
                        return (
                            <div>
                                <el-image style="width:64px;height:64px;margin-right:8px;" src={img[0]} preview-src-list={img} lazy></el-image>
                            </div>
                        )
                    }
                },
                { label: '标题', prop: 'title', minWidth: '200' },
                { label: '创建时间', prop: 'createdTime', minWidth: '100' },
                { label: '最近编辑时间', prop: 'updatedTime', minWidth: '100' },
                {
                    label: '状态', prop: 'statusLabel', minWidth: '130',
                    render: (h, scope) => {
                        let vv = ''
                        if (scope.row.statusLab == '启用') {
                            vv = <p style="color:#303033;font-size:14px;display:flex;justify-content:center;"><div style="width: 10px;height: 10px;background: #13CE4B;border-radius: 50%;opacity: 1;margin-top:7px;margin-right:4px"></div>
                                <div>{scope.row.statusLab}</div>
                            </p>
                        } else {
                            vv = <p style="color:#303033;font-size:14px;display:flex;justify-content:center;"><div style="width: 10px;height: 10px;background:  #F63C56;border-radius: 50%;opacity: 1;margin-top:7px;margin-right:4px"></div>
                                <div>{scope.row.statusLab}</div>
                            </p>
                        }
                        return (
                            <div> {vv}</div>
                        )
                    }
                },

                {
                    label: '操作',
                    minWidth: '80',
                    fixed: 'right',
                    render: (h, scope) => {
                        return (
                            <div>
                                <span style='color:#2D46EE;cursor:pointer;margin-right:10px' onClick={() => { this.options('edit', scope.row.id) }}>编辑</span>
                                <span style='color:#2D46EE;cursor:pointer;margin-right:10px' onClick={() => { this.updateStatus(scope.row) }}>{scope.row.statusL}</span>
                                <span style='color:#2D46EE;cursor:pointer' onClick={() => { this.deleteD(scope.row) }}>删除</span>
                            </div >
                        )
                    }
                }],
            page: { pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' },
            list: [
                {

                }
            ],
            isD: false,
            isS: false,
            isL: false,
            form: {
                banner: '',
            },
            statusS: '',
            uId: ''
        }
    },
    created() {
        // this.getType()
        // this.getPageList()
    },
    beforeRouteEnter(to, from, next) {
        if (from.name == 'addOrEditComment') {
            next(vm => {
                vm.getType()
                vm.getPageList();
            });
        } else {
            next(vm => {
                vm.getType()
                vm.getPageList();
            });
        }
    },
    methods: {
        fetchData(type) {
            this.page.pageNo = 1;
            if (type == 'reset') {
                this.$refs['searchForm'].resetFields()
                this.value1 = []
                this.value2 = []
                this.searchForm.createdTimeStart = ''
                this.searchForm.createdTimeEnd = ''
                this.searchForm.updatedTimeStart = ''
                this.searchForm.updatedTimeEnd = ''
                this.searchForm.title = ''
                this.searchForm.status = ''
            }
            this.getPageList()
        },
        toArticleComment() {
            this.$router.push({
                name: 'articleComment',
                query: { goodsArticleCategoryId: Number(this.activeIndex) + 1 }
            })
        },
        options(type, id) {
            this.$router.push({
                name: 'addOrEditComment',
                query: {
                    id: id,
                    type: type,
                    goodsArticleCategoryId: Number(this.activeIndex) + 1
                }
            })
        },
        changeImage(file) {
            console.log(file)
            this.fileList = file
        },
        uploadBanner() {
            this.isL = true
            this.fileList = []
            this.getBanner()
        },
        getBanner() {
            let id = Number(this.activeIndex) + 1
            this.axios.get('/goodsArticleCategory/getLoopImages?id=' + id)
                .then(res => {
                    console.log(res, '444')
                    res.data.forEach(item => {
                        let obj = {
                            mainFlag: false,
                            url: item
                        }
                        this.fileList.push(obj)
                    })



                })
        },
        handleSelect(e) {
            console.log(e)
            this.activeIndex = e
            this.page.pageNo = 1
            this.$refs['searchForm'].resetFields()
            this.value1 = []
            this.value2 = []
            this.searchForm.createdTimeStart = ''
            this.searchForm.createdTimeEnd = ''
            this.searchForm.updatedTimeStart = ''
            this.searchForm.updatedTimeEnd = ''
            this.searchForm.title = ''
            this.searchForm.status = ''
            this.getPageList()
        },
        getType() {
            this.axios.post('/goodsArticleCategory/pageList', {
                pageNo: 1,
                pageSize: 2000
            }).then(res => {
                console.log(res)
                this.btns = res.data.list
            })
        },
        getPageList() {
            if (this.value1 && this.value1.length > 0) {
                this.searchForm.createdTimeStart = this.value1[0];
                this.searchForm.createdTimeEnd = this.value1[1];
            } else {
                this.searchForm.createdTimeStart = ''
                this.searchForm.createdTimeEnd = ''
            }
            if (this.value2 && this.value2.length > 0) {
                this.searchForm.updatedTimeStart = this.value2[0];
                this.searchForm.updatedTimeEnd = this.value2[1];
            } else {
                this.searchForm.updatedTimeStart = ''
                this.searchForm.updatedTimeEnd = ''
            }
            this.searchForm.pageNo = this.page.pageNo;
            this.searchForm.pageSize = this.page.pageSize;
            this.searchForm.goodsArticleCategoryId = Number(this.activeIndex) + 1
            this.axios.post('/goodsArticle/pageList', this.searchForm)
                .then(res => {
                    console.log(res)
                    res.data.list.forEach(item => {
                        if (item.status == 1) {
                            item.statusL = '禁用'
                        } else {
                            item.statusL = '启用'

                        }
                        item.mainImageArr = []
                        if (item.mainImg.indexOf(',') != -1) {
                            item.mainImageArr = item.mainImg.split(',')
                        } else {
                            item.mainImageArr.push(item.mainImg)
                        }
                        // item.mainImageArr.push(item.mainImg.split(',')[0])
                    })
                    this.list = res.data.list;
                    this.page.totalNum = res.data.totalNum;
                })
        },
        onMultipleSelection(e) {
            console.log(e)
            this.selectD = e
        },
        handleSizeChange(e) {
            this.page.pageSize = e;
            this.page.pageNo = 1;
            this.getPageList()
        },
        handleCurrentChange(e) {
            this.page.pageNo = e;
            this.getPageList()
        },
        updateStatus(row) {
            this.isS = true
            this.statusS = row.status
            this.uId = row.id
        },
        deleteD(row) {
            this.isD = true
            this.selectD.push(row)
        },
        deleteAll() {
            if (this.selectD.length > 0) {
                this.isD = true
            } else {
                this.$message.error('请选择要删除的数据')
            }
        },
        submitA() {
            let status = ''
            if (this.statusS == 1) {
                status = 0
            } else {
                status = 1
            }
            let data = {
                goodsArticleId: this.uId,
                status: status
            }
            this.axios.post('/goodsArticle/toggle', data).then(res => {
                console.log(res)
                if (res.code == 0) {
                    this.$message.success('更改成功')
                    this.getPageList()
                    this.isS = false
                }
            })
        },
        submitD() {
            let goodsArticleIds = []
            this.selectD.forEach(item => {
                goodsArticleIds.push(item.id)
            })
            let data = {
                goodsArticleIds: goodsArticleIds

            }
            this.axios.post('/goodsArticle/delete', data).then(res => {
                console.log(res)
                if (res.code == 0) {
                    this.$message.success('删除成功')
                    this.getPageList()
                    this.isD = false
                }
            })
        },
        submitL() {
            let loopImgs = []
            this.fileList.forEach(item => {
                loopImgs.push(item.url)
            })
            let data = {
                goodsArticleCategoryId: Number(this.activeIndex) + 1,
                loopImgs: loopImgs
            }
            this.axios.post('/goodsArticleCategory/saveLoopImages', data).then(res => {
                console.log(res)
                if (res.code == 0) {
                    this.$message.success('修改成功')
                    this.isL = false
                }
            })
        }
    }


}
</script>
<style lang="scss" scoped>
.p-info {
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 16px;
    color: #909099;
    margin-bottom: 18px
}

.info1 {
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    line-height: 0px;
    color: #303033;
    line-height: 60px;
}

.el-menu--horizontal>.el-menu-item.is-active {
    border-bottom: 2px solid #2d46ee;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #303033;
}

.el-menu.el-menu--horizontal {
    border-bottom: none;
}

.el-menu--horizontal>.el-menu-item {
    height: 44px;
    line-height: 60px;
    font-size: 16px;
    margin-right: 24px;
    width: 76px;
    text-align: center;
    padding: 0;
}

.title {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.info {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 30px;
    color: #303033;
    opacity: 1;
    text-align: center;
}

.info-q {
    width: 124px;
    height: 40px;
    line-height: 40px;
    background: #ffffff;
    border: 1px solid #909099;
    opacity: 1;
    border-radius: 3px;
    text-align: center;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #909099;
    margin-right: 18px;
    cursor: pointer;
}

.info-s {
    width: 126px;
    height: 40px;
    line-height: 40px;
    background: #2d46ee;
    opacity: 1;
    border-radius: 3px;
    text-align: center;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    cursor: pointer;
}
</style>